@if ($active()) {
  <div class="bulk-actions-content">
    <wb-button [label]="$items().length + ' selected'" iconRight="fa-regular fa-xmark" tooltip="Clear selected items" (onClick)="clear.emit()" />

    @if ($directCommands().length) {
      <w-divider />
      @for (cmd of $directCommands(); track cmd._id) {
        <wb-button [command]="cmd" (onClick)="onDirectCommand(cmd)" />
      }
    }

    @if ($showActionsPalette()) {
      <w-divider />
      <wb-button [command]="$actionsCommand()" (onClick)="onActions()" />
    }
  </div>
}
